<div class="step-main-wrapper">
    <h1>{{'create-assignment.skill-type' | translate}}</h1>
    <div class="options-wrapper" *ngIf="utilityOptions.length">
        <h3>{{'create-assignment.options' | translate}}</h3>
        <p *ngIf="this?.selectedUtilityOptions?.length == 0 && !this.choose"
            [innerHTML]="'create-assignment.no-options' | translate"></p>
        <p *ngIf="this.choose">Choose competence first</p>
        <div class="row">
            <div class="option d-flex justify-content-between gap-2"
                *ngFor="let option of this?.selectedUtilityOptions">
                <div class="d-flex justify-content-start gap-2">
                    <img src="{{option?.imagePath}}" alt="option-image" loading="lazy">
                    <p>{{option?.name}}</p>
                </div>
                <img class="close-icon" loading="lazy" src="/assets/img/Close.svg" alt="close"
                    (click)="onRemoveOption(option)">
            </div>
        </div>
        <p class="edit-options-p" *ngIf="!this?.choose" (click)="this.editOptionsModal = true">
            {{'create-assignment.edit-options' | translate}}</p>
    </div>
</div>

<div class="step-2-new">
    <div class="container">
        <div class="sidebar">
            <div class="tab blue" data-tab="arbetare" *ngFor="let skill of this.skills"
                [ngClass]="selectedSkill?.id == skill?.id ? 'active' : ''" (click)="onSelectedCompetence(skill)">
                <span class="icon">
                    <img [src]="skill?.imagePath || skill?.uniform?.imagePath || '/assets/img/shield-new.svg'"
                        loading="lazy" alt="skill icon">
                </span>
                <div class="skill-content">
                    <div class="title">{{ skill | skillDisplayName }}</div>
                    <div class="desc-wrapper" *ngIf="skill?.description || skill?.description_en">
                        <div class="desc"
                            [innerHTML]="currentLang === 'sv' ? skill?.description : skill?.description_en">
                        </div>
                        <div class="tooltip-box">
                            <div class="skill-description" [innerHTML]="
                            currentLang === 'sv'
                                ? skill?.description
                                : skill?.description_en
                        "></div>
                        </div>
                    </div>
                </div>
                <i>
                    <img [src]="selectedSkill?.id == skill?.id ? '../../../../../assets/img/Arrow-right-blue.svg' : '../../../../../assets/img/Arrow-right.svg'"
                        alt="arrow-right" loading="lazy">
                </i>
            </div>
        </div>

        <div class="content" #uniformOptions>
            <div class="tab-content" id="arbetare" style="display: block;">
                <div class="header">
                    <i>
                        <img src="{{selectedSkill?.uniform?.imagePath || '../../../../../assets/img/shield-new.svg'}}"
                            alt="uniform" loading="lazy">
                    </i>
                    <h2>{{ selectedSkill | skillDisplayName }}</h2>
                </div>

                <div class="main-tav-card-box">
                    <div class="card" *ngFor="let uniform of this?.uniforms; trackBy: trackByUniform"
                        [ngClass]="selectedUniform?.name == uniform?.name ? 'active' : ''"
                        (click)="onSelectedUniform(uniform); onSaveAndContinue()" style="cursor: pointer;">
                        <div class="card-image">
                            <img src="{{uniform?.imagePath || '../../../../../assets/img/image01.webp'}}"
                                alt="Uniform Image" loading="lazy" />
                        </div>
                        <div class="card-body">
                            <div class="d-flex justify-content-between align-items-center">
                                <h4 class="m-0">
                                    <span class="icon">
                                        <img src="{{uniform?.imagePath || '../../../../../assets/img/vest-solid.svg'}}"
                                            alt="uniform-icon" loading="lazy">
                                    </span>
                                    <span [title]="uniform?.name">
                                        {{ getTruncatedName(uniform?.name) }}
                                    </span>


                                </h4>
                                <span class="badge rounded-pill bg-success"
                                    *ngIf="selectedUniform?.name == uniform?.name">
                                    {{'create-assignment.step2.selected' | translate}}
                                </span>
                            </div>

                            <div class="tooltip-wrapper my-2">
                                <a href="javascript:void(0)" class="!flex !items-center !gap-2 !m-0">
                                    {{'create-assignment.view-detailed-specifications' | translate}}
                                    <i><img src="../../../../../assets/img/info.svg" alt="info" loading="lazy"></i>
                                </a>

                                <div class="tooltip-box" *ngIf="uniform?.description_en || uniform?.description_sv">
                                    <div class="uniform-description" [innerHTML]="
                                            currentLang === 'sv'
                                                ? uniform?.description_sv
                                                : uniform?.description_en
                                        "></div>
                                </div>
                            </div>

                            <button [ngClass]="selectedUniform?.name == uniform?.name ? 'active':'not_active'"
                                aria-label="Select Option">
                                {{ (selectedUniform?.name === uniform?.name ? 'create-assignment.step2.selected' :
                                'create-assignment.select-option') | translate }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="bottom-sheet" [ngClass]="{ 'visible': showBottomSheet }">
    <div class="sheet-content">
        <div class="left-info">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="#2563eb" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-calendar" aria-hidden="true" data-id="element-538">
                <path d="M8 2v4"></path>
                <path d="M16 2v4"></path>
                <rect width="18" height="18" x="3" y="4" rx="2"></rect>
                <path d="M3 10h18"></path>
            </svg>
            <div class="date">
                <p><strong>{{ selectedSkill | skillDisplayName }}</strong></p>
                <p *ngIf="selectedUniform?.name"><span>with {{selectedUniform?.name}}</span></p>
            </div>
        </div>
        <div class="action-buttons">
            <img src="/assets/img/Close.svg" loading="lazy" (click)="selectedUniform=null;showBottomSheet=false"
                alt="close">
            <button class="btn-primary saveButton" (click)="onSaveAndContinue()" aria-label="Confirm Selection">
                <span>Confirm selection</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-chevron-right" aria-hidden="true" data-id="element-546">
                    <path d="m9 18 6-6-6-6"></path>
                </svg></button>
        </div>
    </div>
</div>